(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["azz-selected-variant"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('azz-selected-variant')) {
    class AzzSelectedVariant extends HTMLElement {
      /** @type {AbortController | null} */
      #abort = null;

      connectedCallback() {
        this.#abort = new AbortController();
        const { signal } = this.#abort;
        const root = this.closest('.shopify-section, dialog, product-card') || document;

        root.addEventListener(
          'shopify:product:select',
          (event) => {
            const productId = this.dataset.productId;
            if (productId && event.detail?.product?.id && String(event.detail.product.id) !== String(productId)) {
              return;
            }

            const sourceCard = event.target?.closest?.('product-card');
            if (sourceCard && !sourceCard.contains(this)) return;

            event.promise
              ?.then(({ detail }) => {
                const resource = detail?.resource;
                const textEl = this.querySelector('[data-azz-selected-variant-text]');
                if (!textEl) return;

                let next = resource?.public_title || resource?.title || resource?.name || '';
                if (!next || next === 'Default Title') {
                  const picker = root.querySelector('variant-picker');
                  const checked = picker
                    ? Array.from(picker.querySelectorAll('fieldset input:checked'))
                    : [];
                  next = checked.map((input) => input.value).filter(Boolean).join(' / ');
                }

                if (next) {
                  textEl.textContent = next;
                  this.classList.remove('azz-selected-variant--empty');
                }
              })
              .catch(() => {});
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.#abort?.abort();
      }
    }

    customElements.define('azz-selected-variant', AzzSelectedVariant);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["azz-stock-delivery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('azz-stock-delivery')) {
    class AzzStockDelivery extends HTMLElement {
      /** @type {AbortController | null} */
      #abort = null;

      connectedCallback() {
        this.#abort = new AbortController();
        const { signal } = this.#abort;
        const root = this.closest('.shopify-section, dialog, product-card') || document;

        root.addEventListener(
          'shopify:product:select',
          (event) => {
            const productId = this.dataset.productId;
            if (productId && event.detail?.product?.id && String(event.detail.product.id) !== String(productId)) {
              return;
            }

            const sourceCard = event.target?.closest?.('product-card');
            if (sourceCard && !sourceCard.contains(this)) return;

            event.promise
              ?.then(({ detail }) => {
                const resource = detail?.resource;
                const stockEl = this.querySelector('[data-azz-stock-label]');
                if (!stockEl) return;

                const available = resource?.available !== false && resource?.available !== 'false';
                stockEl.textContent = available
                  ? this.dataset.inStock || 'In stock'
                  : this.dataset.outOfStock || 'Out of stock';
              })
              .catch(() => {});
          },
          { signal }
        );
      }

      disconnectedCallback() {
        this.#abort?.abort();
      }
    }

    customElements.define('azz-stock-delivery', AzzStockDelivery);
  }
  } catch(e) { console.error(e); }
})();

})();
